import request from '@/utils/request'

export function getPackageApi(query) {
  return request({
    url: '/config-service/v1/package/package',
    method: 'get',
    params: query
  })
}
export function getAllPackageApi() {
  return request({
    url: '/config-service/v1/package/package/all',
    method: 'get'
  })
}
export function getPackageApibyId(id) {
  return request({
    url: `/config-service/v1/package/package/${id}`,
    method: 'get'
  })
}

export function addPackageApi(query) {
  return request({
    url: '/config-service/v1/package/package',
    method: 'post',
    data: query
  })
}

export function updatePackageApi(query) {
  return request({
    url: '/config-service/v1/package/package',
    method: 'put',
    data: query
  })
}
export function deletePackageApi(query) {
  return request({
    url: '/config-service/v1/package/package',
    method: 'delete',
    data: query
  })
}
